import { AnimatePresence, motion } from "framer-motion";
import { FiAlertCircle } from "react-icons/fi";
import { useState } from "react";
import "./SpringModal.css"; // Import the CSS file

const ExampleWrapper = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="wrapper">
            <button
                onClick={() => setIsOpen(true)}
                className="open-button"
            >
                Open Modal
            </button>
            <SpringModal isOpen={isOpen} setIsOpen={setIsOpen} />
        </div>
    );
};

export const SpringModal = ({ isOpen, setIsOpen }) => {
    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={() => setIsOpen(false)}
                    className="modal-container"
                >
                    <motion.div
                        initial={{ scale: 0, rotate: "12.5deg" }}
                        animate={{ scale: 1, rotate: "0deg" }}
                        exit={{ scale: 0, rotate: "0deg" }}
                        onClick={(e) => e.stopPropagation()}
                        className="modal-content"
                    >
                        <FiAlertCircle className="alert-icon" />
                        <div className="modal-content-inner">
                            <div className="i-icon-middle">
                                <FiAlertCircle />
                            </div>
                            <h3 className="big-text">
                                One more thing!
                            </h3>
                            <p className="text">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Id
                                aperiam vitae, sapiente ducimus eveniet in velit.
                            </p>
                            <div className="button-group">
                                <button
                                    onClick={() => setIsOpen(false)}
                                    className="button decline"
                                >
                                    Nah, go back
                                </button>
                                <button
                                    onClick={() => setIsOpen(false)}
                                    className="button accept"
                                >
                                    Understood!
                                </button>
                            </div>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default ExampleWrapper;
